module.exports = __webpack_public_path__ + "media/images/guides/random-07-c751eebf06bedfc7ea03fc2d19e1b622.svg";